import React, { Suspense, Fragment, lazy } from "react";
import { Routes, Navigate, Route } from "react-router-dom";

import Loader from "./components/Loader/Loader";
import AdminLayout from "./layouts/AdminLayout";

import GuestGuard from "./components/Auth/GuestGuard";
import AuthGuard from "./components/Auth/AuthGuard";
import AdminGuard from "./components/Auth/AdminGuard";

import { BASE_URL } from "./config/constant";
const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Element = route.element;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            element={
              <Guard>
                <Layout>
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Element props={true} />
                  )}
                </Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  </Suspense>
);

export const routes = [
  {
    exact: "true",
    guard: GuestGuard,
    path: "/auth/signin-2",
    element: lazy(() => import("./views/auth/signin/SignIn2")),
  },
  {
    exact: "true",
    path: "/404",
    element: lazy(() => import("./views/errors/NotFound404")),
  },
  {
    exact: "true",
    path: "/maintenance/coming-soon",
    element: lazy(() => import("./views/maintenance/ComingSoon")),
  },
  {
    exact: "true",
    path: "/maintenance/error",
    element: lazy(() => import("./views/maintenance/Error")),
  },
  {
    exact: "true",
    path: "/maintenance/offline-ui",
    element: lazy(() => import("./views/maintenance/OfflineUI")),
  },
  {
    exact: "true",
    path: "/auth/signup-1",
    element: lazy(() => import("./views/auth/signup/SignUp1")),
  },
  {
    exact: "true",
    path: "/auth/signup-2",
    element: lazy(() => import("./views/auth/signup/SignUp2")),
  },
  {
    exact: "true",
    path: "/auth/signin-1",
    element: lazy(() => import("./views/auth/signin/SignIn1")),
  },
  {
    exact: "true",
    path: "/auth/signin-2",
    element: lazy(() => import("./views/auth/signin/SignIn2")),
  },
  {
    exact: "true",
    path: "/auth/reset-password-1",
    element: lazy(() => import("./views/auth/reset-password/ResetPassword1")),
  },
  {
    exact: "true",
    path: "/auth/reset-password-2",
    element: lazy(() => import("./views/auth/reset-password/ResetPassword2")),
  },
  {
    exact: "true",
    path: "/auth/change-password",
    element: lazy(() => import("./views/auth/ChangePassword")),
  },
  {
    exact: "true",
    path: "/auth/profile-settings",
    element: lazy(() => import("./views/auth/ProfileSettings")),
  },
  {
    exact: "true",
    path: "/view/otp/:email",
    element: lazy(() => import("./views/auth/reset-password/VerifyOTP")),
  },
  {
    exact: "true",
    path: "/view/verifypass/:token",
    element: lazy(() => import("./views/auth/reset-password/VerifyPass")),
  },
  {
    exact: "true",
    path: "/auth/signout",
    element: lazy(() => import("./views/auth/signin/Logout")),
  },
  {
    exact: "true",
    guard: AuthGuard,
    path: "/auth/tabs-auth",
    element: lazy(() => import("./views/auth/TabsAuth")),
  },
  {
    exact: "true",
    guard: AuthGuard,
    path: "/auth/tabs-auth",
    element: lazy(() => import("./views/auth/TabsAuth")),
  },

  {
    exact: "true",
    layout: AdminLayout,
    guard: AdminGuard,
    path: "/hr/postapproval-changes",
    element: lazy(() => import("./views/sales/PostApprovalChanges")),
  },

  {
    exact: "true",
    layout: AdminLayout,
    guard: AdminGuard,
    path: "/hr/admin-datesales",
    element: lazy(() => import("./views/sales/AdminDateSales")),
  },
  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/quote/viewsingle-quotations",
    element: lazy(() => import("./views/stores/ViewSingleQuotes")),
  },
  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/quote/reports",
    element: lazy(() => import("./views/stores/Reports")),
  },
  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/settings/stock-management",
    element: lazy(() => import("./views/stores/StockManagement")),
  },
  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/quote/viewCombined-quotations",
    element: lazy(() => import("./views/stores/ViewCombQuotes")),
  },

  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/settings/general-settings",
    element: lazy(() => import("./views/stores/GeneralSettings")),
  },

  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/customers/Supplier-list",
    element: lazy(() => import("./views/stores/SupplierSettings")),
  },
  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/settings/catalog-settings",
    element: lazy(() => import("./views/stores/UpdatePriceCatalogue")),
  },
  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/settings/hp-settings",
    element: lazy(() => import("./views/stores/HirepurchaseSettings")),
  },
  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/settings/tariff-settings",
    element: lazy(() => import("./views/stores/TariffSettings")),
  },

  {
    exact: "true",
    layout: AdminLayout,
    guard: AdminGuard,
    path: "/hr/admin-shopsales",
    element: lazy(() => import("./views/sales/AdminSalesByShop")),
  },

  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/quote/single-quote",
    element: lazy(() => import("./views/stores/NewSingleQuote")),
  },
  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/quote/combined-quote",
    element: lazy(() => import("./views/stores/CombinedQuotes")),
  },
  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/quote/none-stock-quote",
    element: lazy(() => import("./views/stores/NoneStockQuote")),
  },
  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/quote/combined-none-stock-quote",
    element: lazy(() => import("./views/stores/NoneStockQuoteCombined")),
  },
  {
    exact: "true",
    layout: AdminLayout,
    guard: AdminGuard,
    path: "/quote/comp-dash",
    element: lazy(() => import("./views/stores/CompanyDash")),
  },

  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/inventory/transfer-request",
    element: lazy(() => import("./views/shop-operations/TransferRequests")),
  },

  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/inventory/order-requisition",
    element: lazy(() => import("./views/shop-operations/OrderRequisition")),
  },

  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/receipts/HirePurchaseOverpayments",
    element: lazy(() => import("./views/accounts/HirePurchaseOverpayments")),
  },

  {
    path: "*",
    layout: AdminLayout,
    guard: AuthGuard,
    routes: [
      {
        exact: "true",
        path: "/app/dashboard/analytics",
        element: lazy(() => import("./views/dashboard/DashAnalytics")),
      },
      {
        exact: "true",
        path: "/customers/customer/:id",
        element: lazy(() => import("./views/customers/CustomerDetails")),
      },
      {
        exact: "true",
        path: "/customers/customer-list",
        element: lazy(() => import("./views/customers/CustomerList")),
      },
      {
        exact: "true",
        path: "/hr/select-shop",
        element: lazy(() => import("./views/sales/SelectShop")),
      },
      {
        exact: "true",
        path: "/hr/error",
        element: lazy(() => import("./views/sales/Error")),
      },
      {
        exact: "true",
        path: "/hr/view-sales",
        element: lazy(() => import("./views/sales/ViewSales")),
      },
      {
        exact: "true",
        path: "/hr/sales-date",
        element: lazy(() => import("./views/sales/SalesByDate")),
      },
      {
        exact: "true",
        path: "/hr/sales-shop",
        element: lazy(() => import("./views/sales/SalesByShop")),
      },

      {
        exact: "true",
        path: "/inventory/purchase-order",
        element: lazy(() => import("./views/shop-operations/PurchaseOrders")),
      },
      {
        exact: "true",
        path: "/inventory/receive-order",
        element: lazy(() => import("./views/shop-operations/ReceiveGoods")),
      },
      {
        exact: "true",
        path: "/accounts/new-receipt",
        element: lazy(() => import("./views/accounts/NewReceipt")),
      },
      {
        exact: "true",
        path: "/accounts/receipt-handing-over",
        element: lazy(() => import("./views/accounts/ReceiptHandingOver")),
      },
      {
        exact: "true",
        path: "/accounts/unbanked-receipts",
        element: lazy(() => import("./views/accounts/UnbankedReceipts")),
      },
      {
        exact: "true",
        path: "/sales/sale-process",
        element: lazy(() => import("./views/sales/Sale")),
      },
      {
        exact: "true",
        path: "/sales/all-sale",
        element: lazy(() => import("./views/sales/AllSales")),
      },
      {
        exact: "true",
        path: "/sales/hp-all-sale",
        element: lazy(() => import("./views/sales/HPAllSales")),
      },
      {
        exact: "true",
        path: "/sales/discount-requests",
        element: lazy(() => import("./views/sales/DiscountRequests")),
      },
      {
        exact: "true",
        path: "/payments/view-payments",
        element: lazy(() => import("./views/accounts/ViewPayments")),
      },
      {
        exact: "true",
        path: "/sales/hp-accounts",
        element: lazy(() => import("./views/customers/HpAccounts")),
      },
      {
        exact: "true",
        path: "/sales/hp-safari",
        element: lazy(() => import("./views/sales/HpSafari")),
      },
      {
        exact: "true",
        path: "/sales/hp-amortization",
        element: lazy(() => import("./views/sales/HpAmortization")),
      },
      {
        exact: "true",
        path: "/gaa/reject-pos",
        element: lazy(() => import("./views/shop-operations/PoRejection")),
      },

      {
        exact: "true",
        path: "/inventory/stock-adjustments",
        element: lazy(() => import("./views/shop-operations/StockAdjustment")),
      },

      {
        exact: "true",
        path: "/accounts/gltrans-view",
        element: lazy(() => import("./views/accounts/GlTransView")),
      },

      {
        exact: "true",
        path: "/customers/stock-item-sno",
        element: lazy(() => import("./views/accounts/EditItemSerial")),
      },
      {
        exact: "true",

        path: "/stocks/stockanalysis",
        element: lazy(() => import("./views/stores/StockValAnalysis")),
      },
      {
        exact: "true",
        path: "/receipts/temporary-receipts",
        element: lazy(() => import("./views/accounts/NewPartDeposits")),
      },
      {
        exact: "true",
        path: "/receipts/view-part-deposits",
        element: lazy(() => import("./views/accounts/ViewPartDeposits")),
      },
      {
        exact: "true",
        path: "/receipts/petty cash-tr-suspense",
        element: lazy(() => import("./views/accounts/PettyCashTrSusp")),
      },
      {
        exact: "true",
        path: "/financials/bank-reconciliation",
        element: lazy(() => import("./views/accounts/BankReconciliation")),
      },
      {
        exact: "true",
        path: "/financials/view-journals",
        element: lazy(() => import("./views/accounts/ViewJournals")),
      },
      {
        exact: "true",
        path: "/financials/chart-accounts",
        element: lazy(() => import("./views/accounts/ChartOfAccounts")),
      },
      {
        exact: "true",
        path: "/financials/banks",
        element: lazy(() => import("./views/accounts/Banks")),
      },
      {
        exact: "true",
        path: "/financials/company-banks",
        element: lazy(() => import("./views/accounts/CfsCompanyBanks")),
      },
      {
        exact: "true",
        path: "/payments/cheque-writing",
        element: lazy(() => import("./views/accounts/ChequeWriting")),
      },
      {
        exact: "true",
        path: "/settings/tran-codes",
        element: lazy(() => import("./views/accounts/CfsTransactionCodes")),
      },
            {
        exact: "true",
        path: "/settings/inspecting-ss",
        element: lazy(() => import("./views/shop-operations/InspectingSS")),
      },
      {
        path: "*",
        exact: "true",
        element: () => <Navigate to={BASE_URL} />,
      },
    ],
  },
];

export default renderRoutes;
